export const CSP_NONCE_PLACEHOLDER = "__CSP_NONCE__";

export function getCspNonce() {
  const metaNonce = document
    .querySelector('meta[name="csp-nonce"]')
    ?.getAttribute("content");

  if (metaNonce && metaNonce !== CSP_NONCE_PLACEHOLDER) {
    return metaNonce;
  }

  const scriptNonce = document.querySelector("script[nonce]")?.nonce;

  return scriptNonce && scriptNonce !== CSP_NONCE_PLACEHOLDER ? scriptNonce : "";
}
